






















































import { Component, Prop, Vue } from "vue-property-decorator";
import { IResource, mapServiceTypeToIcon } from "@/types/resource";
import ResourceDropdown from "@/components/Resource/ResourceDropdown.vue";

@Component({
  components: { ResourceDropdown },
})
export default class ResourceItem extends Vue {
  @Prop({ required: true, type: Object }) resource!: IResource;

  @Prop({ required: false, default: false }) inline!: boolean;
  @Prop({ required: false, default: false }) preview!: boolean;

  list = [];

  mapServiceTypeToIcon = mapServiceTypeToIcon;

  get urlHostname(): string | undefined {
    if (this.resource?.resourceUrl) {
      return new URL(this.resource.resourceUrl).hostname.replace(
        /^(www\.)/,
        ""
      );
    }
    return undefined;
  }
}
